const FX_CACHE_KEY = 'intouch-fx-rates-v1';
const EXCHANGE_CACHE_KEY = 'exchange-prices-usd-cache-v2';
import { getRuntimeResilienceSummary, trackRuntimeMetric } from '@/lib/observability/runtime-metrics';

export interface RuntimeRecoveryResult {
  actions: string[];
  cleared: string[];
  summaryStatus: 'stable' | 'degraded' | 'critical';
}

export function clearRuntimeRecoveryCaches(): { cleared: string[] } {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return { cleared: [] };
  }

  const cleared: string[] = [];

  try {
    window.localStorage.removeItem(FX_CACHE_KEY);
    cleared.push(FX_CACHE_KEY);
  } catch {
    // Ignore storage permission/quota issues.
  }

  try {
    window.localStorage.removeItem(EXCHANGE_CACHE_KEY);
    cleared.push(EXCHANGE_CACHE_KEY);
  } catch {
    // Ignore storage permission/quota issues.
  }

  return { cleared };
}

export function applyRecommendedRuntimeRecovery(): RuntimeRecoveryResult {
  const summary = getRuntimeResilienceSummary();
  const actions: string[] = [];
  let cleared: string[] = [];

  const hasFxOrExchangeSignal = summary.recommendations.some((item) => {
    const normalized = item.toLowerCase();
    return normalized.includes('fx') || normalized.includes('exchange') || normalized.includes('demo mode');
  });

  if (summary.status !== 'stable' && hasFxOrExchangeSignal) {
    const result = clearRuntimeRecoveryCaches();
    cleared = result.cleared;
    if (result.cleared.length > 0) {
      actions.push('Cleared FX and exchange caches');
      trackRuntimeMetric('runtime.recovery.cache_clear');
    }
  }

  if (actions.length === 0) {
    actions.push('No automated recovery action required');
  }

  return {
    actions,
    cleared,
    summaryStatus: summary.status,
  };
}
